import React, { useEffect, useRef } from 'react';
import Pusher from 'pusher-js';
import Echo from 'laravel-echo';
import { store } from '../reduxStore/store';

window.Pusher = Pusher;
const WsComponent = () => {
    const echoRef = useRef(null);
    const authenticatedUser = store?.getState()?.authReducer?.authenticatedUser;
    const userId = authenticatedUser?.id;
    const profileId = authenticatedUser?.profile_id;
    const last_access_token = store?.getState()?.authReducer?.sessionSettings?.last_access_token ?? '';

    useEffect(() => {
        const disableWebSocket = true; // Until it's not final

        if (!profileId || !last_access_token || disableWebSocket) {
            console.warn("WebSocket skipped: Missing profileId or access token");

            return;
        }

        try {
            if (!echoRef.current) {
                echoRef.current = new Echo({
                    broadcaster: 'reverb',
                    key: process.env.REACT_APP_REVERB_APP_KEY, //process.env.REACT_APP_REVERB_APP_KEY,
                    forceTLS: process.env.REACT_APP_REVERB_SCHEME === 'https',
                    encrypted: process.env.REACT_APP_REVERB_SCHEME === 'https',
                    wsHost: process.env.REACT_APP_REVERB_HOST,
                    wsPort: process.env.REACT_APP_REVERB_PORT ? parseInt(process.env.REACT_APP_REVERB_PORT) : 6001,
                    wssPort: process.env.REACT_APP_REVERB_PORT ? parseInt(process.env.REACT_APP_REVERB_PORT) : 433,
                    disableStats: true,
                    enabledTransports: ['ws', 'wss'],
                    authEndpoint: process.env.REACT_APP_REVERB_AUTH_URL,
                    auth: {
                        headers: {
                            Authorization: `Bearer ${last_access_token}`,
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json'
                        },
                        credentials: 'include', // Ensure cookies & tokens are sent
                    },
                });

                // Error handling
                echoRef.current.connector.pusher.connection.bind('error', (err) => {
                    console.error('WebSocket Error:', err);
                });

                echoRef.current.connector.pusher.connection.bind('disconnected', () => {
                    console.warn('WebSocket disconnected, attempting to reconnect...');
                });

                echoRef.current.connector.pusher.connection.bind('reconnecting', () => {
                    console.info('WebSocket reconnecting...');
                });

                echoRef.current.connector.pusher.connection.bind('connected', () => {
                    console.info('WebSocket connected');
                });
            }

            const echo = echoRef.current;

            // Subscribe to channels
            const notificationsChannel = echo.private(`notifications.${profileId}`);
            const conversationsChannel = echo.private(`conversations.${userId}`);

            notificationsChannel.listen('.new-notification', (event) => {
                console.log('New notification:', event);
            });

            conversationsChannel.listen('.new-message', (event) => {
                console.log('New message:', event);
            });

            return () => {
                try {
                    if (notificationsChannel) {
                        notificationsChannel.stopListening('.new-notification');
                        echo.leave(`notifications.${profileId}`);
                    }
                    if (conversationsChannel) {
                        conversationsChannel.stopListening('.new-message');
                        echo.leave(`conversations.${userId}`);
                    }
                } catch (cleanupError) {
                    console.error("Error during WebSocket cleanup:", cleanupError);
                }
            };
        } catch (error) {
            console.error("WebSocket initialization error:", error);
        }
    }, [profileId, last_access_token]);

    return <div></div>;
};

export default WsComponent;
